import React from 'react'
import Loading from './Loading'

function LoadingFullScreen() {
  return (
    <div className='loading-full-screen'><Loading/></div>
  )
}

export default LoadingFullScreen